var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('hero',{attrs:{"title":_vm.$t('login.title')}}),_vm._v(" "),_c('card-component',{attrs:{"title":_vm.$t('login.title'),"icon":"ballot"}},[_c('login-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }